<template>
    <a-drawer
      :title="'获奖信息-'+actionName"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="onClose"
      width="30%"
    >
        <div class="input-box">
            <p>获奖类别：</p>
            <a-input class="input" v-model="info.winningType" :disabled="actionName=='查看'"/>
        </div>
        <div class="input-box">
            <p>获奖等级：</p>
            <a-select class="input" allowClear v-model="info.winningGrade" :disabled="actionName=='查看'">
                <a-select-option v-for="(item,index) in hjdjArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
        </div>
        <div class="input-box">
            <p>获奖成果名称：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.winningName" />
        </div>
        <div class="input-box">
            <p>证书编号：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.winningNo" />
        </div>
        <div class="input-box">
            <p>完成人：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.winner" />
        </div>
        <div class="input-box">
            <p>获奖时间：</p>
            <a-date-picker class="input" :disabled="actionName=='查看'" v-model="info.winningDate" @change="(date, dateString)=>{info.winningDate=dateString}"/>
        </div>
        <div class="input-box">
            <p>主要支撑学科：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.supportSubject" />
        </div>
        <div class="input-box">
            <p>参与学科数：</p>
            <a-input-number class="input" :disabled="actionName=='查看'" v-model="info.participateSubject" />
        </div>
        <div class="btn-box">
            <a-button type="primary" @click="sub" v-if="actionName!='查看'">提交</a-button>
            <a-button @click="onClose">取消</a-button>
        </div>
    </a-drawer>
</template>

<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { add,update,info } from '@/baseAPI/research/price'
    export default {
        name: '',
        components: {
        },
        computed: {},
        data() {
            return {
                actionName:'',
                visible:false,
                id:'',
                info:{
                    winningType:null,
                    winningGrade:null,
                    winningName:null,
                    winningNo:null,
                    winner:null,
                    winningDate:null,
                    supportSubject:null,
                    participateSubject:null,
                },
                hjdjArr:[],
            }
        },
        mounted () {
        },
        methods:{
            getInfo(){
                getDicts({dataCode:'KYCG-HJDJ',status:true}).then(res=>{
                    this.hjdjArr=res.data.dicts;
                    this.info.winningGrade=res.data.defaultValue[0]
                })
                if(this.actionName!='新增'){
                    info(this.id).then(res=>{
                        this.info=res.data;
                        this.teacherSearch(this.info.courseDirectorNo)
                    })
                }
            },
            showDrawer(name,id){
                this.id=id;
                this.actionName=name;
                this.getInfo();
                this.visible=true;
            },
            onClose() {
                this.info={
                    winningType:null,
                    winningGrade:null,
                    winningName:null,
                    winningNo:null,
                    winner:null,
                    winningDate:null,
                    supportSubject:null,
                    participateSubject:null,
                };
                this.visible = false;
                this.$parent.fetch()
            },
            handSearch(value){
                if(value!=''){
                    this.info.consProjectTypeCode=value
                }
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            sub(){
                var isSub=true;
                var arr=['remark','approvalStatus','courseAttrName']
                for(let key in this.info){
                    if(arr.indexOf(key)<0){
                        if(this.info[key]==null||this.info[key]===''){
                            isSub=false;
                            break;
                        }
                    }
                }
                if(isSub){
                    if(this.actionName=='新增'){
                        add(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'新增获奖成功',
                                });
                                this.onClose()
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }else{
                        update(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'修改获奖成功',
                                });
                                this.onClose()
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }
                }else{
                    this.$notification['warning']({
                        message: '警告',
                        description:'请填写完整！',
                    });
                }
            },

        }
    }
</script>

<style scoped>
    .ant-drawer >>> .ant-drawer-header{
        background-color: #245086;
        border-radius: 0;
    }
    .ant-drawer >>> .ant-drawer-title{
        color: #fff;
        font-weight: bold;
        letter-spacing: 1px;
        font-size: 1.1rem;
    }
    .input-box{
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
        position: relative;
    }
    .input-box p{
        width: 8rem;
        text-align: right;
    }
    .input-box .input{
        width: calc(100% - 8rem);
    }
    .input-box .tips{
        width: calc(100% - 8rem);
        position: absolute;
        right: 0;
        top: 100%;
        font-size: 13px;
        line-height: 20px;
        color: #1890ff;
    }
    .btn-box{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        text-align: right;
        padding-bottom: 1rem;
        background-color: #fff;
    }
    .btn-box .ant-btn{
        margin-right: 2rem;
    }
    .input>>>.ant-input[disabled],.ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }

</style>
